export default __webpack_public_path__ + "static/media/photo3.70847779.jpg";